export enum ServiceType {
  ENTERPRISE = 'ENTERPRISE',
  API = 'API',
  BONDSCREENER_EXPORT = 'BondscreenerExport',
}
